import React, { useState } from 'react';
import { toast } from 'react-toastify';
import { ExportToCsv } from 'export-to-csv-fix-source-map';
import { FailToastContainer } from 'components/Toast/ToastContainer';
import { sanitizeFileName } from 'utils';
import { IExportCSV } from 'utils/csvformatter';
import Button from './Button';

const BASE_CSV_OPTIONS = {
  fieldSeparator: ',',
  quoteStrings: '"',
  decimalSeparator: '.',
  showLabels: true,
  showTitle: false,
  useTextFile: false,
  useBom: true,
  useKeysAsHeaders: false,
};

interface IExportCSVButtonProps {
  fileName: string;
  label?: string;
  disabled?: boolean;
  exportFunc: () => Promise<IExportCSV>;
}

const ButtonExportCSVAsync = ({ exportFunc, fileName, label = 'Export', disabled, ...rest }: IExportCSVButtonProps) => {
  const [clicked, setClicked] = useState<boolean>(false);

  const handleExport = async () => {
    try {
      setClicked(true);
      const response = await exportFunc();
      const sanitizedFileName = sanitizeFileName(fileName.replace('.csv', ''));
      const csvExporter = new ExportToCsv({ ...BASE_CSV_OPTIONS, headers: response.headers, filename: sanitizedFileName });
      csvExporter.generateCsv(response.data || []);
    } catch (err: any) {
      toast(<FailToastContainer title="Error" message="Unable to download csv, please try again." />);
    } finally {
      setClicked(false);
    }
  };

  return <Button appearance="primary" size="small" label={label} isProcessing={clicked} disabled={disabled} onClick={handleExport} data-cy="export-btn" {...rest} />;
};

export default ButtonExportCSVAsync;
